<template>
  <div class="diensten-container"></div>
</template>

<script>
export default {
  name: 'Diensten',
  props: {},
  metaInfo: {
    title: 'Diensten - Langglas',
    meta: [
      {
        property: 'og:title',
        content: 'Diensten - Langglas',
      },
    ],
  },
}
</script>

<style scoped>
.diensten-container {
  width: 100%;
  display: flex;
  overflow: auto;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
}
</style>
